@if (forecastModel.length) {
    <div class="racing-post-pick">
        <div class="forecast-container">
            <div class="forecast-details-betslip">
                <div class="timeform">
                    @for (participant of forecastModel; track participant.id; let index = $index) {
                        <div class="participant">
                            <div class="participant-name">{{ index + 1 }} {{ participant.name | msTranslate }}</div>
                            <div class="participant-rating">
                                <ms-star-rating [rating]="participant.timeformInfo?.ratingStars" />
                            </div>
                        </div>
                        <div class="divider"></div>
                    }
                </div>
                <div class="picks-container" [ngClass]="{ racingpostdisabled: isracingpostPickDisabled }">
                    <ms-race-xcast-pick
                        class="forecast-tricast-button timeform-pick-button"
                        [fixture]="fixture"
                        [participants]="forecastModel"
                        [marketType]="marketType"
                        [pickType]="participantPickType"
                        [optionGroup]="optionGroup"
                        [participantOptionGroups]="participantOptionGroups"
                        [enableOptionIndicator]="false"
                        [trackingSource]="trackingSource"
                        [trackingOptions]="trackingOptions"
                        [class.disabled]="isButtonDisabled()"
                        (selected)="pickSelected($event)">
                        @if (!isButtonDisabled()) {
                            <div class="forecast-tricast-info">
                                @switch (isForecastSelected) {
                                    @case (false) {
                                        <span>{{ addTimeFormPost }}</span>
                                    }
                                    @case (true) {
                                        <span>{{ timeFormPostAdded }}</span>
                                    }
                                }
                            </div>
                        }
                        @if (isButtonDisabled()) {
                            <div class="lock"><i class="theme-locked-i"></i></div>
                        }
                    </ms-race-xcast-pick>
                </div>
            </div>
        </div>
    </div>
}
